import { memo } from "react";
import { Button, Flex, Heading, Text, Image } from "@chakra-ui/react";
import iconMail from "assets/img/auth/icon-mail.svg";

interface Step1VerifyEmailProps {
  email: string;
  isVerifying: boolean;
  isLoggingIn?: boolean;
  onNext: () => void;
  isNextDisabled?: boolean;
  onBack: () => void;
  onVerifyLater?: () => void;
}

export const VerifyEmail = memo(function VerifyEmail({
  email,
  isVerifying,
  isLoggingIn,
  onNext,
  isNextDisabled,
  onBack,
  onVerifyLater,
}: Step1VerifyEmailProps) {
  return (
    <Flex
      direction="column"
      alignItems="center"
      textAlign="center"
      w="100%"
      backgroundColor="#FFFFFF"
    >
      <Flex mb="24px" alignItems="center" justifyContent="center" gap="16px">
        <Image src={iconMail} w="97px" h="97px" alt="Email icon" />
      </Flex>

      <Heading fontSize="24px" fontWeight="600" mb="12px" color="navy.700">
        Verify your email
      </Heading>

      <Text fontSize="16px" color="gray.600" mb="32px" maxW="400px">
        We've sent a verification link to your email: {email || "xxx@gmail.com"}. Please
        click the link in your email to continue.
      </Text>

      <Button
        w="100%"
        h="48px"
        fontSize="16px"
        bgColor="#3A7BFF"
        fontWeight="600"
        color="#FFFFFF"
        borderRadius="25px"
        border="1px solid #3A7BFF"
        mb="12px"
        _hover={{
          bgColor: "#FFFFFF",
          color: "#3A7BFF",
        }}
        _active={{
          bgColor: "#FFFFFF",
          color: "#3A7BFF",
        }}
        _loading={{ pointerEvents: "none" }}
        onClick={onNext}
        isLoading={isVerifying}
        isDisabled={isNextDisabled}
      >
        Next
      </Button>

      <Button
        w="100%"
        h="48px"
        bgColor="white"
        color="#3A7BFF"
        borderRadius="24px"
        fontSize="14px"
        fontWeight="600"
        border="1px solid #3A7BFF"
        mb="16px"
        _hover={{
          bgColor: "#3A7BFF",
          color: "#FFF",
        }}
        _active={{
          bgColor: "#FFFFFF",
          color: "#3A7BFF",
        }}
        onClick={onBack}
      >
        Back
      </Button>

      {onVerifyLater ? (
        <Button
          variant="link"
          fontSize="14px"
          color="#4285F4"
          fontWeight="500"
          onClick={onVerifyLater}
          isLoading={isLoggingIn}
          isDisabled={isLoggingIn}
          _hover={{ textDecoration: "underline" }}
        >
          Verify later
        </Button>
      ) : null}
    </Flex>
  );
});
